<template>
	<div class="setting">
		<van-nav-bar
			:title="type === 'name' ? '修改姓名' : '修改昵称'"
			left-arrow
			@click-left="onClickLeft"
			right-text="保存"
			@click-right="accountProfileSave"
		/>
		<div class="setting-box">
			<div class="setting-item flex-space-between" v-if="type === 'name'">
				<van-cell-group>
					<van-field v-model="name" clearable placeholder="请输入姓名" maxlength="15" class="" />
				</van-cell-group>
			</div>
			<div class="setting-item flex-space-between" v-else>
				<van-cell-group>
					<van-field v-model="nickname" clearable placeholder="请输入昵称" maxlength="15" class="" />
				</van-cell-group>
			</div>
			<p class="tip-tex">可输入1-15个字</p>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	name: 'edit',
	data() {
		return {
			name: '',
			nickname: '',
			headImage: '',
			text: '可输入1-15个字',
			type: 'name', //修改姓名、昵称
		}
	},
	computed: {
		...mapState(['userInfo']),
	},
	created() {
		// 修改昵称或姓名
		this.type = this.$route.query.type
		this.name = this.userInfo.name || ''
		this.nickname = this.userInfo.nickname || ''
		this.headImage = this.userInfo.headImage
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1)
		},
		accountProfileSave() {
			if (this.type === 'name' && this.name.length > 15) {
				return
			}

			if (this.type === 'nickname' && this.nickname.length > 15) {
				return
			}

			if (this.type === 'nickname' && !this.nickname.length) {
				this.$toast('昵称不能为空')
				return
			}

			const params = {
				name: this.name,
				nickname: this.nickname,
				headImage: this.headImage,
			}
			const that = this
			this.$api.user.updateUser(params).then((res) => {
				if (res.success) {
					// 触发用户信息状态
					that.$store.commit('setUserInfo', {
						nickname: this.nickname,
					})
					that.$store.commit('setUserInfo', {
						name: this.name,
					})
					this.$toast({
						message: '修改成功',
						onClose: function() {
							console.debug(this)
							that.$router.go(-1)
						},
					})
				}
			})
		},
	},
}
</script>
<style lang="stylus" scoped>
.flex-space-between{
    display :flex;
    justify-content:space-between;
    align-items :center;
}
.align-items-center{
    display :flex;
    align-items :center;
}
.setting{
    .tip-tex{
        color:#999;
        font-size:26px;
        margin-top :12px;
        text-align :right;
        padding:0 30px;
    }
    background:#F7F7F7;
    height:100vh;
    .setting-box{
        margin-top:30px;
    }
    .setting-item{
        .van-cell-group{
            width:100%;
        }
        .van-cell{
            padding:17px 15px;
        }
        &:p:nth-child(1){
            padding:20px 0;
        }
        .setting-item-left{
            color:#333333;
        }
        .setting-item-right{
            img{
                width:100px;
                height:100px;
                border-radius:50%;
            }
            p{
                color:#666;
                font-size:26px;
            }
        }
    }
}
</style>
